<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.student.studentImport')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.student.studentImport')}}</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="border border-dark p-2 mb-5">
                                    <a href="/templates/CSV-Sample-StudentImport.csv" class="mb-3 d-block"
                                        download>{{$t('form.import.download')}}</a>

                                    <div class="font-weight-bold">{{$t('form.import.requirement')}}</div>
                                    <ul>
                                        <li>{{$t('form.import.requirement1')}}</li>
                                        <li>{{$t('form.import.requirement2', {format: dateFormat})}}</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-md-7">
                                <b-form-checkbox class="mb-4" v-model="header">
                                    {{$t('form.import.csvHeader')}}
                                    <br />
                                    <span class="font-weight-normal">{{$t('form.import.csvHeaderText')}}</span>
                                </b-form-checkbox>

                                <b-form-checkbox class="mb-4" v-model="delimiter">
                                    {{$t('form.import.csvDelimiter')}}
                                    <br />
                                    <span class="font-weight-normal">{{$t('form.import.csvDelimiterText')}}</span>
                                </b-form-checkbox>

                                <b-form-checkbox class="mb-4" v-model="qualifier">
                                    {{$t('form.import.csvQualifier')}}
                                    <br />
                                    <span class="font-weight-normal">{{$t('form.import.csvQualifierText')}}</span>
                                </b-form-checkbox>
                            </div>

                            <div class="col-md-5">
                                <div class="form-group" v-if="isSBSUser">
                                    <label class="control-label">{{$t('form.student.status')}}</label>
                                    <v-select label="StatusName" :options="statusList" v-model="statusID"
                                        :reduce="statusList => statusList.StatusID"></v-select>
                                </div>

                                <div class="form-group" v-if="isSBSUser">
                                    <label class="control-label">{{$t('form.student.studentStatusComment')}}</label>
                                    <input type="text" v-model="statusComment" class="form-control" />
                                </div>

                                <div class="form-group">
                                    <label class="control-label">{{$t('form.student.uploadFile')}}</label>

                                    <vue-dropzone @vdropzone-sending="importingData"
                                         id="dropzone"
                                        :dictCancelUpload="true"
                                         ref="myVueDropzone"
                                        :options="dropzoneOptions" @vdropzone-complete="fileSubmitted"
                                        @vdropzone-processing="isLoading=true"></vue-dropzone>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import vue2Dropzone from "vue2-dropzone";

    export default {
        props: ["permissions", "dateFormat", "user"],
        components: {
            vueDropzone: vue2Dropzone
        },

        data() {
            return {

                studentList:[],
                importFileHeader:[],
                isAccepted:false,
                filePath:'',
                alert: false,
                alertClass: "",
                alertMessage: "",

                isLoading: false,
                fullPage: true,

                dropzoneOptions: {
                    url: "/api/students/import",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                header: true,
                delimiter: true,
                qualifier: false,
                statusID: null,
                statusComment: '',
                statusList: []
            };
        },

        mounted() {

            if (!this.permissions.createImportStudents) {
                this.$router.push("/");
                return;
            }

            this.getStatuses();
            let  savedRecordStatus = window.localStorage.getItem('dataSaved');
            if(savedRecordStatus)
            {
                this.showAlert(savedRecordStatus);
                window.localStorage.removeItem('dataSaved');
            }
        },

        computed: {
            isSBSUser() {
                return this.user.partner_id == 1;
            },
        },

        methods: {

            getStatuses() {
                this.isLoading = true;

                axios
                    .get("/api/statuses?import")
                    .then(response => {
                        this.statusList = response.data;
                        this.isLoading = false;
                    })
                    .catch(error => (this.isLoading = false));
            },


            showData(event)
            {
                  let   read = new FileReader();

                    read.readAsBinaryString(event);

                    read.onloadend = function(){
                        console.log(read.result);
                    }

            },


            importingData(file, xhr, formData) {
                formData.append("heading_row", this.header ? 1 : 0);
                formData.append("delimiter", this.delimiter ? 1 : 0);
                formData.append("qualifier", this.qualifier ? 1 : 0);
                formData.append("get_array", 1);

                // send status if sbs user
                if (this.isSBSUser && this.statusID) {
                    formData.append("status_id", this.statusID);
                    formData.append("status_comment", this.statusComment);
                }
            },

           async fileSubmitted(response) {
                this.isLoading = false;

                let data = await JSON.parse(response.xhr.response);

                 if (response.status == "success") {
                    this.studentList = data.data.students;
                    localStorage.setItem('students',JSON.stringify(this.studentList))
                    localStorage.setItem('duplicates',JSON.stringify(data.data.duplicates))
                    localStorage.setItem('path',data.data.path)

                    if (this.isSBSUser && this.statusID) {
                        localStorage.setItem('status_id', this.statusID)
                        localStorage.setItem('status_comment', this.statusComment)
                    }
                    this.showAlert(data.message);

                      this.$router.push({name: 'StudentImportPreview'});

                 }

                else if (response.status == "error") {
                    this.showAlert(data.message, "danger");
                }
            },

            showAlert(msg, cls = "success") {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    };

</script>
